import React, { useCallback, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import useStore from "../stores/useStore";
import LoaderVWC from "../components/LoaderVWC";
import useHttp from "../hooks/use-http";

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Callback = () => {
  const { isAuthenticated, isLoading, loginWithRedirect, user } = useAuth0();
  const navigate = useNavigate();
  const { redirectUri, resetRedirectUri, setUser } = useStore();

  const {
    sendRequest: userManagementRequest,
    isLoading: userManagementLoading,
    error: userManagementError,
  } = useHttp();

  // Callback die de response van user_management verwerkt
  const handleUserManagementResponse = useCallback(
    (res) => {
      if (res.type === "EMAIL_NOT_VERIFIED") {
        navigate("/email-not-verified");
      } else {
        // Email is geverifieerd, redirect naar opgeslagen URI of default
        const destination = redirectUri || "/";
        navigate(destination);
        if (redirectUri) {
          resetRedirectUri();
        }
      }
    },
    [redirectUri, navigate, resetRedirectUri]
  );

  // Als de gebruiker is ingelogd, controleer email verificatie en redirect
  useEffect(() => {
    if (isLoading) return;

    if (!isAuthenticated) {
      loginWithRedirect();
      return;
    }

    // Gebruiker is authenticated, sla user op en check email verificatie
    setUser(user);

    userManagementRequest(
      {
        url: `${REACT_APP_BACKEND_URL}/user_management`,
        method: "POST",
      },
      handleUserManagementResponse
    );
  }, [
    isLoading,
    isAuthenticated,
    user,
    loginWithRedirect,
    userManagementRequest,
    handleUserManagementResponse,
    setUser,
  ]);

  return <LoaderVWC compact />;
};

export default Callback;
